import React from 'react';
import {SelectField, SelectInput} from 'react-admin';

const genders = [
  { id: '01', name: 'eTrangThaiHoc.01' },
  { id: '02', name: 'eTrangThaiHoc.02' },
  { id: '03', name: 'eTrangThaiHoc.03' },
  { id: '04', name: 'eTrangThaiHoc.04' },
  { id: '05', name: 'eTrangThaiHoc.05' },
  { id: '06', name: 'eTrangThaiHoc.06' },
  { id: '07', name: 'eTrangThaiHoc.07' },
  { id: '08', name: 'eTrangThaiHoc.08' },
  { id: '09', name: 'eTrangThaiHoc.09' },
  { id: '10', name: 'eTrangThaiHoc.10' },
  { id: '11', name: 'eTrangThaiHoc.11' },
  { id: '12', name: 'eTrangThaiHoc.12' },
]

export const ETrangThaiHocField = (props) => (
  <SelectField source={props.source} choices={genders} {...props} />
)

